// Ported from the Polaris kit: src/components/ui/marker/index.js.
// Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
// Change the design in the kit first, then re-port.
import { cva } from 'class-variance-authority';

export { default as Marker } from './Marker.vue';
export { default as MarkerContent } from './MarkerContent.vue';
export { default as MarkerIcon } from './MarkerIcon.vue';

export const markerVariants = cva(
  "gap-2 type-polaris-body text-polaris-muted-foreground [&:is(a)]:hover:text-polaris-foreground [&:is(a)]:underline-offset-[3px] [&:is(a)]:underline [&_svg:not([class*='size-'])]:size-4 min-h-4 text-left group/marker relative flex w-full items-center",
  {
    variants: {
      variant: {
        default: '',
        separator:
          'before:h-px before:min-w-0 before:flex-1 before:bg-polaris-border after:h-px after:min-w-0 after:flex-1 after:bg-polaris-border before:mr-1 after:ml-1',
        border: 'border-b border-solid border-polaris-border pb-2',
      },
    },
  }
);
